import { ErrorBoundary } from '@/components/ErrorBoundary'
import { ColorModeProvider } from '@/components/ui/color-mode'
import { Toaster } from '@/components/ui/Toast'
import { AuthProvider } from '@/features/auth/context/AuthContext'
import { queryClient } from '@/lib/queryClient'
import { AppRoutes } from '@/routes'
import system from '@/theme'
import { ChakraProvider } from '@chakra-ui/react'
import { QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'

function App() {
  return (
    <ChakraProvider value={system}>
      <ColorModeProvider>
        <QueryClientProvider client={ queryClient }>
          <BrowserRouter>
            <AuthProvider>
              <ErrorBoundary>
                <AppRoutes />
              </ErrorBoundary>
            </AuthProvider>
          </BrowserRouter>
        </QueryClientProvider>
        <Toaster />
      </ColorModeProvider>
    </ChakraProvider>
  )
}

export default App
